import { useHistory, useLocation } from "react-router";
import {
  AllClinicRoutes,
  ClinicDashBoardRoute,
} from "../../../clinic/ClinicRoutes";
import { useCallback } from "react";
import { getRouteRegex } from "fe-common/routes/commonPathUtils";

export const useClinicNavigator = () => {
  const location = useLocation();
  const history = useHistory();

  const getCurrentClinicDashboardRoute = (path: string) => {
    const matchExec = getRouteRegex(
      Object.values(ClinicDashBoardRoute).join("|"),
    ).exec(path);
    if (!matchExec) return null;
    return matchExec[1] as ClinicDashBoardRoute;
  };

  /*TODO: implment search parmas and */
  const goToRoute = useCallback(
    (
      route: AllClinicRoutes,
      options?: { prams?: any; keepParams?: boolean; pathAdditions?: string },
    ) => {
      const path = location.pathname.split("/");
      const last = path.pop();

      if (!getCurrentClinicDashboardRoute(last)) {
        path.pop();
      }
      history.push(
        `${path.join("/")}/${route}${
          options?.pathAdditions ? "/" + options.pathAdditions : ""
        }`,
      );
    },
    [location, history],
  );

  return { goToRoute };
};
